/**
 * Select2 Serbian translation.
 */
(function ($) {
	"use strict";

	$.fn.select2.locales['sr'] = {
		formatMatches: function (matches) { if (matches === 1) { return "Pronađen je jedan rezultat, pritisnite enter da izaberete."; } return matches + " rezultata je pronađeno, koristite strelice gore i dole za navigaciju."; },
		formatNoMatches: function () { return "Nema pronađenih rezultata"; },
		formatInputTooShort: function (input, min) { var n = min - input.length; return "Unesite još " + n + " karakter" + (n == 1 ? "" : "s"); },
		formatInputTooLong: function (input, max) { var n = input.length - max; return "Obrišite " + n + " karakter" + (n == 1 ? "" : "s"); },
		formatSelectionTooBig: function (limit) { return "Možete izabrati samo " + limit + " stavk" + (limit == 1 ? "" : "s"); },
		formatLoadMore: function (pageNumber) { return "Učitavanje još rezultata…"; },
		formatSearching: function () { return "Pretraga…"; }
	};

	$.extend($.fn.select2.defaults, $.fn.select2.locales['sr']);
})(jQuery);
